/*
 *   File : restart-sip.js
 *   Author : https://evoqins.com
 *   Description : Restart cancelled sip modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// Components
import { PrimaryButton, SecondaryButton } from "../Buttons";
import { Icon } from "../Icon"

function RestartSIPModal(props) {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("sip-restart-modal-close");
        button.click();
        props.handleClose();
    };

    // handle success
    const _handleSuccess = () => {
        var button = document.getElementById("sip-restart-modal-close");
        button.click();
        props.handleSuccess();
    };

    return (
        <div className="modal fade"
            id="sip-restart-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="SipRestartModalLabel"
            aria-hidden="true">

            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16 modal-lg px-lg-5">
                <span id='sip-restart-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-16 border-0 mx-lg-5">
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-end align-items-center pt-3 px-3 pb-0">
                        <Icon icon="close-icon"
                            size="20px"
                            className="cursor-pointer"
                            onPress={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body py-0 px-3 text-center'>
                        <img src={require("../../Assets/Images/Modal/restart-sip.png")}
                            draggable={false}
                            width={200}
                            alt='broker' />

                        <h4 className='padding-12px-top mb-2 e-text-primary-color e-primary-font-clash-display e-font-18 e-font-weight-500 line-height-22px'>
                            Restart SIP
                        </h4>
                        <p className='px-5 mb-0 e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-20px'>
                            Are you ready to restart your SIP? Resuming your SIP will reinitiate regular investments for this plan, helping you stay on track with your financial goals.
                        </p>
                    </div>
                    {/* Modal footer */}
                    <div className='modal-footer border-0 padding-40px-lr padding-20px-tb d-block'>
                        <div className="d-flex flex-column flex-sm-row gap-2 gap-sm-3">

                            <SecondaryButton name="Cancel"
                                className="w-100 flex-fill e-letter-spacing-min-point-1px e-font-16 e-font-14-res"
                                padding="padding-18px-tb e-padding-8px-all-res"
                                onPress={_handleSuccess} />
                            <PrimaryButton name="Restart SIP"
                                className="w-100 flex-fill e-letter-spacing-min-point-1px e-font-16 e-font-14-res"
                                padding="padding-18px-tb e-padding-8px-all-res"
                                onPress={_handleSuccess} />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default RestartSIPModal